import React from "react";
import { Route } from "react-router-dom";
import AccessControl from "../../../components/utilities/Class/AccessControl";
import Billing from "../../../containers/modules/sales/billing";
import CashSales from "../../../containers/modules/sales/cash-sales";

export default function CashSalesRoute(props) {
  const { authUser } = props;
  return (
    <Route
      path="cash-sales"
      index
      element={
        <AccessControl
          name={"Cash Sales List"}
          auth={authUser}
          component={() => <CashSales />}
        />
      }
    />
  );
}
